export const translations = {
  id: {
    nav: {
      home: "Beranda",
      about: "Tentang Kami",
      services: "Layanan Kami",
      expo: "Expo",
      events: "Acara",
      career: "Karir"
    },
    
    hero: {
      title: "eventimeofficial.com",
      tagline: "The future of event is here",
      exploreServices: "Jelajahi Layanan Kami",
      learnMore: "Pelajari Lebih Lanjut",
      stats: {
        events: "Acara Berhasil",
        communities: "Komunitas Aktif",
        support: "Dukungan"
      },
      scroll: "Scroll"
    },

    about: {
      title: "Tentang Eventime",
      vision: {
        title: "Visi Kami",
        description: "Menjadi mitra terdepan dalam menciptakan pengalaman event dan menghidupkan momen, dari gagasan kecil komunitas event hingga expo event."
      },
      mission: {
        title: "Misi Kami",
        connect: "<strong>Menciptakan Koneksi Bernilai:</strong> Menghubungkan brand dengan audiens yang tepat melalui event yang terkurasi dan berorientasi hasil.",
        promote: "<strong>Memaksimalkan Eksposur:</strong> Merancang strategi promosi dan sponsorship untuk meningkatkan exposure, engagement, dan nilai bisnis.",
        execute: "<strong>Eksekusi Tanpa Kompromi:</strong> Mengelola operasional event secara end-to-end agar setiap detail berjalan lancar dan profesional."
      },
      pillars: {
        title: "Pilar Branding Kami",
        range: "Dari Community Event sampai Expo",
        business: {
          title: "Dua Bisnis Inti",
          description: "Manajemen Event Terintegrasi & Platform Komunitas Digital"
        },
        values: "Menciptakan Pengalaman Berkesan & ROI Maksimal untuk Klien",
        impact: "Mendorong Inovasi Lokal & Membangun Ekosistem Event Berkelanjutan"
      },
      values: {
        community: {
          title: "Membangun Komunitas",
          description: "Kami percaya pada kekuatan komunitas dalam menciptakan pengalaman yang berkesan dan membangun hubungan yang berkelanjutan."
        },
        professional: {
          title: "Profesionalisme Tinggi",
          description: "Tim berpengalaman dengan standar internasional dalam setiap aspek penyelenggaraan event, dari perencanaan hingga eksekusi."
        },
        passion: {
          title: "Passion & Dedikasi",
          description: "Kami menjalankan setiap proyek dengan passion penuh dan dedikasi untuk memberikan hasil terbaik bagi klien dan komunitas."
        }
      },
      cta: {
        title: "Mari Wujudkan Event Impian Anda!",
        description: "Dari komunitas kecil hingga expo besar, kami siap menjadi partner terpercaya untuk menciptakan pengalaman event yang tak terlupakan.",
        button: "Konsultasi Sekarang"
      }
    },

    picProfile: {
      title: "Our story",
      meetOurPIC: "Meet our PIC",
      description: "Kami adalah tim yang dibangun oleh tekad dan passion. Kami tidak bisa diam melihat visi untuk membantu Anda memahami motivasi di balik pekerjaan kami dalam menghadirkan event terbaik.",
      quote: "You can't pour from an empty cup. Take care of yourself first."
    },

    services: {
      title: "Layanan Kami",
      subtitle: "Kami menyediakan layanan manajemen event komprehensif untuk komunitas olahraga dan esports Anda.",
      items: {
        sports: {
          title: "Event Olahraga Komunitas",
          description: "Menyelenggarakan event olahraga yang sehat, inklusif, dan berkelanjutan.",
          cta: "Rancang Event Bersama Kami"
        },
        lifestyle: {
          title: "Lifestyle Segment",
          description: "Ciptakan Event Lifestyle yang Tak Terlupakan. Membantu Anda menciptakan ekosistem lifestyle dengan mengkombinasikan industri terkait untuk pengalaman yang autentik.",
          cta: "Bangun Ekosistem Lifestyle"
        },
        esports: {
          title: "Virtual E-Sport & Event Hybrid",
          description: "Merancang format event hybrid yang menggabungkan aktivitas online dan offline untuk engagement yang lebih luas.",
          cta: "Lihat Konsep Event Hybrid"
        },
        expo: {
          title: "Eventime Expo",
          description: "Platform showcase tematik untuk brand dan komunitas yang ingin memperkenalkan produk, ide, dan kolaborasi baru.",
          cta: "Gabung sebagai Partner Expo"
        }
      },
      buttons: {
        askNow: "Tanya Sekarang",
        learnMore: "Pelajari Lebih Lanjut",
        consultation: "Konsultasi"
      },
      why: {
        title: "Kenapa Eventime?",
        experience: {
          title: "Audiens yang Relevan",
          description: "Event kami dirancang untuk mempertemukan brand dengan audiens yang sesuai target."
        },
        team: {
          title: "Peluang Aktivasi Nyata",
          description: "Lebih dari sekadar logo, kami membuka ruang interaksi langsung antara brand dan peserta."
        },
        technology: {
          title: "Operasional yang Siap Jalan",
          description: "Tim profesional memastikan event berjalan lancar, tepat waktu, dan sesuai ekspektasi partner."
        }
      },
      cta: "Konsultasi Gratis",
      modal: {
        aboutService: "Tentang Layanan Ini",
        features: "Yang Termasuk dalam Layanan",
        pastEvents: "Acara yang Pernah Diselenggarakan",
        packages: "Paket Layanan",
        popular: "POPULER",
        duration: "Durasi",
        participants: "Peserta",
        includes: "Termasuk",
        consultation: "Konsultasi Sekarang",
        interested: "Tertarik dengan Layanan Ini?",
        ctaDescription: "Konsultasikan kebutuhan acara Anda dengan tim profesional kami. Gratis dan tanpa komitmen!",
        processing: "Memproses...",
        freeConsultation: "Konsultasi Gratis",
        learnMore: "Pelajari Lebih Lanjut"
      }
    },

    expo: {
      title: "Eventime Expo",
      subtitle: "Platform showcase untuk komunitas dan brand",
      description: "Bergabunglah dengan expo kami dan tampilkan produk atau layanan Anda kepada ribuan pengunjung dari komunitas olahraga dan esports.",
      features: {
        showcase: "Pameran Produk",
        showcaseDesc: "Tampilkan produk terbaru Anda",
        networking: "Jejaring & Relasi",
        networkingDesc: "Bertemu dengan komunitas dan partner",
        workshops: "Workshop & Pelatihan",
        workshopsDesc: "Pembelajaran dan sharing session",
        competitions: "Kompetisi",
        competitionsDesc: "Kompetisi menarik dengan hadiah"
      },
      readyToJoin: "Siap Bergabung sebagai Exhibitor?",
      joinDescription: "Daftarkan brand Anda dan raih exposure langsung ke audiens yang tepat.",
      cta: "Daftar Sebagai Exhibitor"
    },

    events: {
      title: "Incoming Event 2026",
      subtitle: "Event-event menarik yang akan datang",
      viewDetail: "Lihat Detail",
      comingSoon: "Coming Soon",
      comingSoonTitle: "Segera Hadir",
      noEvents: "Belum ada event yang tersedia saat ini",
      cta: {
        title: "Siap Bergabung dengan Event Kami?",
        description: "Jangan lewatkan event-event mendatang kami. Daftar sekarang dan jadilah bagian dari komunitas!",
        button: "Daftar Sekarang"
      },
      contactUs: "Hubungi Kami"
    },

    upcoming: {
      title: "Acara Mendatang",
      subtitle: "Acara-acara menarik yang segera hadir",
      comingSoon: "Segera Hadir",
      datePlaceholder: "Segera Hadir 2026"
    },

    team: {
      title: "Tim Kami",
      subtitle: "Kenalan dengan orang-orang di balik kesuksesan event Anda"
    },

    footer: {
      tagline: "Menghubungkan komunitas olahraga dan esports melalui acara berkesan.",
      description: "Di Eventime, kami percaya bahwa setiap acara adalah kesempatan untuk membangun komunitas yang kuat dan menciptakan pengalaman yang tak terlupakan.",
      navigation: "Navigasi",
      services: "Layanan",
      contact: "Kontak",
      madeWith: "Dibuat dengan",
      forCommunity: "untuk komunitas Indonesia",
      backToTop: "Kembali ke Atas"
    },

    language: {
      switch: "Language",
      indonesian: "Indonesia",
      english: "English"
    },
    
    career: {
      title: "Bergabung dengan Tim Eventime",
      subtitle: "Wujudkan karir impian Anda bersama kami dalam industri event management",
      internship: {
        title: "Program Magang",
        description: "Kesempatan belajar dan berkembang dalam dunia event management dengan bimbingan mentor berpengalaman.",
        instruction: "Kirim CV Anda ke",
        email: "hrd@eventimeofficial.com",
        benefits: ["Mentoring dari profesional", "Proyek nyata", "Sertifikat magang", "Networking luas"]
      },
      fulltime: {
        title: "Karyawan Full-Time", 
        description: "Posisi tetap untuk profesional berpengalaman yang siap berkontribusi dalam tim kami.",
        status: "Tidak Dibuka",
        statusDescription: "Saat ini kami belum membuka lowongan untuk posisi full-time. Pantau terus halaman ini untuk update terbaru."
      },
      sendEmail: "Kirim Email",
      comingSoon: "Segera Hadir",
      contactHR: "Hubungi Kami",
      readyTitle: "Siap Memulai Perjalanan Anda?",
      readyDescription: "Bergabunglah dengan tim dinamis kami dan jadilah bagian dari penciptaan event tak terlupakan yang menyatukan komunitas."
    },


serviceInquiry: "Halo! Saya tertarik untuk konsultasi tentang layanan \"{serviceName}\". Bisakah Anda memberikan informasi lebih lanjut?",
    generalInquiry: "Halo! Saya tertarik dengan layanan Eventime. Bisakah Anda memberikan informasi lebih lanjut?",
    eventInquiry: "Halo! Saya tertarik dengan event-event mendatang dari Eventime. Bisakah Anda memberikan informasi lebih lanjut?",
    registrationInquiry: "Halo! Saya tertarik untuk mendaftar event Eventime. Bisakah Anda memberikan informasi pendaftaran?",
    exhibitorInquiry: "Halo! Saya tertarik untuk berpartisipasi sebagai exhibitor di Eventime Expo. Bisakah Anda memberikan informasi lebih lanjut?",
    contactInquiry: "Halo! Saya ingin bertanya tentang layanan \"{serviceName}\". Bisakah Anda memberikan informasi lebih lanjut?"

  },

  en: {
    nav: {
      home: "Home",
      about: "About us",
      services: "Our services",
      expo: "Expo",
      events: "Events",
      career: "Career"
    },
    
    hero: {
      title: "eventimeofficial.com",
      tagline: "The future of event is here",
      exploreServices: "Explore Our Services",
      learnMore: "Learn More",
      stats: {
        events: "Successful Events",
        communities: "Active Communities",
        support: "Support"
      },
      scroll: "Scroll"
    },

    about: {
      title: "About Eventime",
      vision: {
        title: "Our Vision",
        description: "To become a leading partner in creating event experiences and bringing moments to life, from small community event ideas to expo events."
      },
      mission: {
        title: "Our Mission",
        connect: "<strong>Creating Valuable Connections:</strong> Connecting brands with the right audience through curated, results-oriented events.",
        promote: "<strong>Maximizing Exposure:</strong> Designing promotional and sponsorship strategies to increase exposure, engagement, and business value.",
        execute: "<strong>Uncompromising Execution:</strong> Managing end-to-end event operations to ensure every detail runs smoothly and professionally."
      },
      pillars: {
        title: "Our Brand Pillars",
        range: "From Community Events to Expo",
        business: {
          title: "Two Core Businesses", 
          description: "Integrated Event Management & Digital Community Platform"
        },
        values: "Creating Memorable Experiences & Maximum ROI for Clients",
        impact: "Driving Local Innovation & Building Sustainable Event Ecosystem"
      },
      values: {
        community: {
          title: "Building Community",
          description: "We believe in the power of community to create memorable experiences and build lasting relationships."
        },
        professional: {
          title: "High Professionalism",
          description: "Experienced team with international standards in every aspect of event management, from planning to execution."
        },
        passion: {
          title: "Passion & Dedication",
          description: "We approach every project with full passion and dedication to deliver the best results for clients and community."
        }
      },
      cta: {
        title: "Let's Make Your Dream Event Come True!",
        description: "From small communities to large expos, we are ready to be your trusted partner in creating unforgettable event experiences.",
        button: "Consult Now"
      }
    },

    picProfile: {
      title: "Our story",
      meetOurPIC: "Meet our PIC",
      description: "We are a team built by self-determination and passion. We can't be silent with our vision to help you understand the motivation behind our work in delivering the best events.",
      quote: "You can't pour from an empty cup. Take care of yourself first."
    },

    services: {
      title: "Our Services",
      subtitle: "We provide comprehensive event management services for your sports and esports communities.",
      items: {
        sports: {
          title: "Community Event Sport",
          description: "Organizing healthy, inclusive, and sustainable sports events.",
          cta: "Design Event With Us"
        },
        lifestyle: {
          title: "Lifestyle Segment",
          description: "Create Unforgettable Lifestyle Events. Help you build a lifestyle ecosystem by combining related industries for an authentic experience.",
          cta: "Build Lifestyle Ecosystem"
        },
        esports: {
          title: "Virtual E-Sport & Hybrid Event",
          description: "Design hybrid event formats that combine online and offline activities for wider engagement.",
          cta: "See Hybrid Event Concepts"
        },
        expo: {
          title: "Eventime Expo",
          description: "Thematic showcase platform for brands and communities looking to introduce products, ideas, and new collaborations.",
          cta: "Join as Expo Partner"
        }
      },
      buttons: {
        askNow: "Ask Now",
        learnMore: "Learn More",
        consultation: "Consultation"
      },
      why: {
        title: "Why Eventime?",
        experience: {
          title: "Relevant Audience",
          description: "Our events are designed to connect brands with their target audience."
        },
        team: {
          title: "Real Activation Opportunities",
          description: "More than just a logo, we create spaces for direct interaction between brands and participants."
        },
        technology: {
          title: "Ready-to-Go Operations",
          description: "Professional team ensures events run smoothly, on time, and meet partner expectations."
        }
      },
      cta: "Free Consultation",
      modal: {
        aboutService: "About This Service",
        features: "What's Included in the Service",
        pastEvents: "Past Events Organized",
        packages: "Service Packages",
        popular: "POPULAR",
        duration: "Duration",
        participants: "Participants",
        includes: "Includes",
        consultation: "Consult Now",
        interested: "Interested in This Service?",
        ctaDescription: "Consult your event needs with our professional team. Free and no commitment!",
        processing: "Processing...",
        freeConsultation: "Free Consultation",
        learnMore: "Learn More"
      }
    },

    expo: {
      title: "Eventime Expo",
      subtitle: "Showcase platform for communities and brands",
      description: "Join our expo and showcase your products or services to thousands of visitors from sports and esports communities.",
      features: {
        showcase: "Product Showcase",
        showcaseDesc: "Display your latest products",
        networking: "Networking",
        networkingDesc: "Meet communities and partners",
        workshops: "Workshops",
        workshopsDesc: "Learning and sharing sessions",
        competitions: "Competitions",
        competitionsDesc: "Exciting competitions with prizes"
      },
      readyToJoin: "Ready to Join as an Exhibitor?",
      joinDescription: "Register your brand and seize the opportunity to connect with thousands of visitors.",
      cta: "Register as Exhibitor"
    },

    events: {
      title: "Incoming Event 2026",
      subtitle: "Exciting upcoming events",
      viewDetail: "View Details",
      comingSoon: "Coming Soon",
      comingSoonTitle: "Coming Soon",
      noEvents: "No events available at the moment",
      cta: {
        title: "Ready to Join Our Events?",
        description: "Don't miss out on our upcoming events. Register now and be part of the community!",
        button: "Register Now"
      },
      contactUs: "Contact Us"
    },

    upcoming: {
      title: "Upcoming Events",
      subtitle: "Exciting events coming soon",
      comingSoon: "Coming Soon",
      datePlaceholder: "Coming Soon 2026"
    },

    team: {
      title: "Meet Our Team",
      subtitle: "Get to know the people behind your successful events"
    },

    footer: {
      tagline: "Connecting sports and esports communities through memorable events.",
      description: "At Eventime, we believe that every event is an opportunity to build strong communities and create unforgettable experiences.",
      navigation: "Navigation",
      services: "Services",
      contact: "Contact",
      madeWith: "Made with",
      forCommunity: "for Indonesian communities",
      backToTop: "Back to Top"
    },

    language: {
      switch: "Language",
      indonesian: "Indonesia",
      english: "English"
    },
    
    career: {
      title: "Join the Eventime Team",
      subtitle: "Build your dream career with us in the event management industry",
      internship: {
        title: "Internship Program",
        description: "Learning and growth opportunities in event management with experienced mentor guidance.",
        instruction: "Send your CV to",
        email: "hrd@eventimeofficial.com",
        benefits: ["Professional mentoring", "Real projects", "Internship certificate", "Wide networking"]
      },
      fulltime: {
        title: "Full-Time Employee",
        description: "Permanent positions for experienced professionals ready to contribute to our team.",
        status: "Not Open",
        statusDescription: "We are currently not opening positions for full-time roles. Keep checking this page for latest updates."
      },
      sendEmail: "Send Email",
      comingSoon: "Coming Soon",
      contactHR: "Contact Us",
      readyTitle: "Ready to Start Your Journey?",
      readyDescription: "Join our dynamic team and be part of creating unforgettable events that bring communities together."
    },

    serviceInquiry: "Hello! I'm interested in consulting about \"{serviceName}\" service. Could you provide more information?",
    generalInquiry: "Hello! I'm interested in Eventime services. Could you provide more information?",
    eventInquiry: "Hello! I'm interested in upcoming events from Eventime. Could you provide more information?",
    registrationInquiry: "Hello! I'm interested in registering for Eventime events. Could you provide registration information?",
    exhibitorInquiry: "Hello! I'm interested in participating as an exhibitor at Eventime Expo. Could you provide more information?",
    contactInquiry: "Hello! I would like to ask about \"{serviceName}\" service. Could you provide more information?"
  }
};
